import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

// Validation schema
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
});

// Custom input component - Bootstrap 5 compatible
const CustomInput = ({ field, form, parentClass, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={parentClass || 'mb-3'}>
      <input
        {...field}
        {...props}
        className={`${props.className || 'form-control'} ${hasError ? 'is-invalid' : ''}`}
        disabled={props.disabled}
      />
      {hasError && (
        <div className="invalid-feedback">
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

class CreateFeature extends Component {
  getInitialValues = () => {
    if (this.props.mode === 'EDIT' && this.props.initialValues) {
      return {
        name: this.props.initialValues.name || '',
        description: this.props.initialValues.description || '',
      };
    }
    return {
      name: '',
      description: '',
    };
  };

  handleSubmit = (values, { setSubmitting }) => {
    if (this.props.mode === 'EDIT') {
      this.props.onEdit(values);
    } else {
      this.props.onCreate(values);
    }
    setSubmitting(false);
  };

  render() {
    const { mode, isCreating, isLoading, accessMode } = this.props;

    return (
      <section className="create-piece">
        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={this.getInitialValues()}
              validationSchema={validationSchema}
              onSubmit={this.handleSubmit}
              enableReinitialize={true} // Allow form to reinitialize when props change
            >
              {({ isSubmitting, values, setFieldValue }) => (
                <Form>
                  {/* Name Field */}
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <label className="col-form-label">Name</label>
                    </div>
                    <div className="col-md-9">
                      {mode !== 'EDIT' ? (
                        <Field
                          name="name"
                          type="text"
                          placeholder="Name"
                          component={CustomInput}
                          className={`form-control create-composer__name ${accessMode === 'view' ? 'disabled' : ''}`}
                          parentClass="mb-0"
                          disabled={accessMode === 'view'}
                        />
                      ) : (
                        <div className="mb-0">
                          <input
                            disabled={true}
                            value={values.name}
                            type="text"
                            className="form-control create-composer__name"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Description Field */}
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <label className="col-form-label">Description</label>
                    </div>
                    <div className="col-md-9">
                      <Field
                        name="description"
                        type="text"
                        placeholder="Description"
                        component={CustomInput}
                        className={`form-control ${accessMode === 'view' ? 'disabled' : ''}`}
                        parentClass="mb-0"
                        disabled={accessMode === 'view'}
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  {accessMode === 'edit' && (
                    <div className="row">
                      <div className="col-12">
                        <div className="d-grid">
                          <button
                            className="cus-btn-primary btn-block btn-lg"
                            type="submit"
                            disabled={isCreating || isSubmitting}
                          >
                            {isCreating || isSubmitting ? (
                              <>
                                <div className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
                                Processing...
                              </>
                            ) : (
                              <span>{mode === 'EDIT' ? 'Update' : 'Create'}</span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section>
    );
  }
}

export default CreateFeature;
